import { Dispatch } from 'redux'
import { getApiErrorMessage, getCSRFToken } from '../../lib/utils'
import { SupplierRefinementUpdate } from '../../types/PurchaseItem'
import {
	UPDATE_BULK_SUPPLIERS_ERROR,
	UPDATE_BULK_SUPPLIERS_SENDING,
	UPDATE_BULK_SUPPLIERS_SENT,
} from '../slices/updateBulkSuppliersSlice'
import { NeoniApi, TrackedMutationOptions } from '../../lib/api'

export const refineSuppliers =
	(api: NeoniApi, suppliers: SupplierRefinementUpdate[], accountingPeriodId: string, options?: TrackedMutationOptions) => async (dispatch: Dispatch) => {
		dispatch({
			type: UPDATE_BULK_SUPPLIERS_SENDING,
		})

		try {
			const csrf = await getCSRFToken(options?.signal)
			if (options?.signal?.aborted) return false
			const { onSubmitted, ...requestOptions } = options ?? {}
			onSubmitted?.()

			const body = await api.post('purchases/scope3Refinement', {
				supplierList: suppliers,
				accountingPeriodId: accountingPeriodId,
				_csrf: csrf,

			}, options ? requestOptions : undefined)
			if (options?.signal?.aborted) return false

			if (body.success === true) {
				dispatch({
					type: UPDATE_BULK_SUPPLIERS_SENT,
					payload: body.message,
				})
				return true
			} else {
				dispatch({
					type: UPDATE_BULK_SUPPLIERS_ERROR,
					payload: getApiErrorMessage({ body }, 'Failed to update suppliers. Please try again.'),
				})
				return false
			}
		} catch (error) {
			if (options?.signal?.aborted) return false
			dispatch({
				type: UPDATE_BULK_SUPPLIERS_ERROR,
				payload: getApiErrorMessage(error, 'Failed to update suppliers. Please try again.'),
			})
			return false
		}
	}
